import React from "react";
import { cn } from "@/lib/utils";

export default function KPICard({ title, value, subtitle, trend, accent = "blue", icon, testId, className }) {
  const accentColors = {
    blue: "from-blue-500/20 to-transparent",
    orange: "from-orange-500/20 to-transparent",
    green: "from-emerald-500/20 to-transparent",
    red: "from-red-500/20 to-transparent",
    purple: "from-purple-500/20 to-transparent",
  };
  return (
    <div
      data-testid={testId}
      className={cn(
        "relative bg-[#111827] border border-white/10 rounded-lg p-5 overflow-hidden",
        "hover:border-white/20 transition-all duration-200 group",
        className,
      )}
    >
      <div className={cn("absolute -top-12 -right-12 w-32 h-32 rounded-full blur-2xl bg-gradient-to-br opacity-50", accentColors[accent])} />
      <div className="relative">
        <div className="flex items-start justify-between mb-3">
          <p className="text-[11px] font-medium text-gray-400 uppercase tracking-widest">{title}</p>
          {icon && <div className="text-gray-500 group-hover:text-white transition-colors">{icon}</div>}
        </div>
        <p className="font-mono text-2xl md:text-3xl font-bold text-white">{value}</p>
        {(subtitle || trend) && (
          <p className="mt-2 text-xs text-gray-500 flex items-center gap-2">
            {trend && (
              <span className={cn("font-mono", trend.positive ? "text-emerald-400" : "text-red-400")}>
                {trend.positive ? "↑" : "↓"} {trend.value}
              </span>
            )}
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}
